module.exports = __webpack_public_path__ + "img/link-mdi.cfe17f4b.svg";